
import { defineComponent } from "vue";
import SessionCreate from "@/client/components/session/Create.vue";

export default defineComponent({
  components: {
    SessionCreate,
  },
});
